import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RouteConfig from 'routes/routes';
import { ErrorBoundary } from 'react-error-boundary';
import Toasts from 'components/library/Toasts';
import ServerError from './views/ServerError';
import { logError } from "utils/logs";
import './App.css';
import 'components/library/style/normalize.css';
import 'components/library/style/reset.css';
import 'components/library/style/typography.css';
import 'components/library/style/animation.css';
function App() {
    return (_jsx("div", { className: "App", children: _jsxs(ErrorBoundary, { FallbackComponent: ServerError, onError: logError, children: [_jsx(RouteConfig, {}), _jsx(Toasts, {})] }) }));
}
export default App;
